import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }

  body {
    font-family: ${({ theme }) => theme.fonts.textFont}, sans-serif;
    font-weight: 400;
    font-size: ${({ theme }) => theme.fonts.defaultFontSize};
    margin: 0;
    padding: 0;
    color: ${({ theme }) => theme.colors.primaryColor};

    font-size: 20px;
  }

  a {
    text-decoration: none;
    line-height: 0;
  }

  .my-masonry-grid {
  display: -webkit-box; /* Not needed if autoprefixing */
  display: -ms-flexbox; /* Not needed if autoprefixing */
  display: flex;
  margin-left: -8px; /* gutter size offset */
  width: auto;
}
.my-masonry-grid_column {
  padding-left: 8px; /* gutter size */
  background-clip: padding-box;
}

/* Style your items */
.my-masonry-grid_column > a { /* change div to reference your elements you put in <Masonry> */
  display: block;
  margin-bottom: 8px;
}

`;

export default GlobalStyle;
